// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2_HI9","calendarButtons":"ClockData_calendarButtons__1ANCc"};